import { render } from "./WheelDisplayModeField.vue?vue&type=template&id=7f29637f&scoped=true"
import script from "./WheelDisplayModeField.vue?vue&type=script&lang=ts"
export * from "./WheelDisplayModeField.vue?vue&type=script&lang=ts"

import "./WheelDisplayModeField.vue?vue&type=style&index=0&id=7f29637f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f29637f"

export default script